var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-cash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.364,
    height: 39,
    viewBox: "0 0 45.364 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4444",
    "data-name": "Group 4444",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M45.3,50.656h0L36.735,29.15a.891.891,0,0,0-1.157-.5h0L.831,42.488a.873.873,0,0,0-.356.283A.881.881,0,0,0,0,43.544V66.7a.891.891,0,0,0,.891.891h37.4a.891.891,0,0,0,.891-.891V54.052L44.8,51.813A.89.89,0,0,0,45.3,50.656ZM37.4,65.807H1.781V44.435H37.4ZM14.858,42.658l14.911-5.941a7.085,7.085,0,0,0,5.105,2.2l1.487,3.74Zm24.324,9.481v-8.6a.891.891,0,0,0-.891-.891h-.014l-1.887-4.739a.737.737,0,0,0-.073-.112.88.88,0,0,0-.931-.686,5.325,5.325,0,0,1-4.669-2.011.883.883,0,0,0-1.143-.2,1,1,0,0,0-.126.023l-18.2,7.249a.88.88,0,0,0-.489.476H5.229L35.41,30.636,43.317,50.49Z",
    transform: "translate(0 -28.588)",
    fill: "#0176c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M32.636,200.524a5.325,5.325,0,0,1,3.595,3.591.89.89,0,0,0,.853.636.814.814,0,0,0,.137-.02.827.827,0,0,0,.122.025H58.715a.765.765,0,0,0,.109-.022.829.829,0,0,0,1-.61v0a5.324,5.324,0,0,1,3.595-3.6.879.879,0,0,0,.611-.98.9.9,0,0,0,.026-.132v-7.124a.8.8,0,0,0-.027-.132.878.878,0,0,0-.611-.98,5.319,5.319,0,0,1-3.593-3.6.88.88,0,0,0-.987-.611.843.843,0,0,0-.126-.025H37.343a.839.839,0,0,0-.133.027.88.88,0,0,0-.98.611,5.324,5.324,0,0,1-3.595,3.594.879.879,0,0,0-.611.98.9.9,0,0,0-.025.132v7.124a.822.822,0,0,0,.025.124A.882.882,0,0,0,32.636,200.524Zm1.145-7.875a7.066,7.066,0,0,0,3.924-3.924H58.353a7.068,7.068,0,0,0,3.924,3.924v6.4a7.075,7.075,0,0,0-3.924,3.924H37.7a7.075,7.075,0,0,0-3.924-3.924Z",
    transform: "translate(-28.438 -169.318)",
    fill: "#0176c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M133.343,229.631A5.343,5.343,0,1,0,128,224.288,5.343,5.343,0,0,0,133.343,229.631Zm0-8.905a3.562,3.562,0,1,1-3.562,3.562A3.562,3.562,0,0,1,133.343,220.726Z",
    transform: "translate(-113.752 -197.756)",
    fill: "#0176c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M77.336,257.616A1.336,1.336,0,1,0,76,256.281,1.336,1.336,0,0,0,77.336,257.616Zm0-1.781a.445.445,0,1,1-.445.445A.445.445,0,0,1,77.336,255.836Z",
    transform: "translate(-67.54 -229.748)",
    fill: "#0176c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M253.336,257.616A1.336,1.336,0,1,0,252,256.281,1.336,1.336,0,0,0,253.336,257.616Zm0-1.781a.445.445,0,1,1-.445.445A.445.445,0,0,1,253.336,255.836Z",
    transform: "translate(-223.949 -229.748)",
    fill: "#0176c0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCash);
export default __webpack_public_path__ + "static/media/ic-cash.a9f3994b.svg";
export { ForwardRef as ReactComponent };